import Api from '../../utils/api';
import {API_TREASURES, API_TREASURE_REDEEM} from '../../configs/apis';
import {
  API_TREASURE_FETCH,
  API_TREASURE_FETCH_SUCCESS,
  API_TREASURE_REDEEM_REQUEST,
  API_TREASURE_REDEEM_SUCCESS,
  API_TREASURE_REDEEM_CLEAN,
} from '../types';
import {handleError} from '../error';

export function fetchTreasures(params) {
  return async (dispatch) => {
    try {
      const {appId, ...rest} = params;
      dispatch({type: API_TREASURE_FETCH, ...params});
      const response = await Api.get(API_TREASURES, rest, {appId});
      return dispatch({type: API_TREASURE_FETCH_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function redeemTreasure(params) {
  return async (dispatch) => {
    try {
      const {treasureId} = params;
      dispatch({type: API_TREASURE_REDEEM_REQUEST, ...params});
      const response = await Api.post(API_TREASURE_REDEEM, {}, {treasureId});
      return dispatch({type: API_TREASURE_REDEEM_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function redeemClean(params) {
  return {type: API_TREASURE_REDEEM_CLEAN, params};
}
